import { render, staticRenderFns } from "./ViewLayout.vue?vue&type=template&id=549a912a"
import script from "./ViewLayout.vue?vue&type=script&lang=js"
export * from "./ViewLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports